import React from "react";

export const currencyFormat = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 });

export const formatCifra = (valor, dec = null) => {
    if (dec) {
        const num = parseFloat(valor);
        if (isNaN(num)) return "0.00";

        return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else {
        const num = parseInt(valor);
        if (isNaN(num)) return "0";

        return num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }
};

export const useBasicComponentStates = ({editingForm = false} = {}) => {
	const [loading, setLoading] = React.useState(false);
	const [editing, setEditing] = React.useState(editingForm); //esl estadod e edicion puede inciarse como bool o como []
	const [hasLoaded, setHasLoaded] = React.useState(false);
	const [empty, setEmpty] = React.useState(true);
	const [error, setError] = React.useState(false);

	return{
		loading, setLoading,
		editing, setEditing,
		hasLoaded, setHasLoaded,
		empty, setEmpty,
		error, setError,
	}
}